import React from "react";
import { Box, Rating as MUIRating, Stack } from "@mui/material";
import { useApp, useTheme } from "contexts";
import { Custom } from "components";

// icons
import { StarRounded } from "@mui/icons-material";

type Props = {
  name: string;
  value: number;
  onChange: (name: string, value: number) => void;
  max?: number; // default 5
  iconColor?: string; // e.g. "#1976d2"
  IconComponent?: React.ElementType;
  labels?: string[]; // e.g. ["Bad", "Poor", "Okay", "Good", "Excellent"]
};

export const Rating: React.FC<Props> = ({
  name,
  value,
  onChange,
  max = 5,
  iconColor,
  IconComponent = StarRounded,
}) => {
  const { t } = useApp();
  const { theme } = useTheme();

  return (
    <Box component="div">
      <Stack
        width={1}
        direction="column"
        alignItems="center"
        px={theme.spacing.md}
      >
        <MUIRating
          max={max}
          name={name}
          value={value}
          onChange={(_, newValue) => onChange(name, newValue)}
          icon={
            <IconComponent fontSize="inherit" style={{ color: iconColor }} />
          }
          emptyIcon={
            <IconComponent
              fontSize="inherit"
              style={{ color: theme.color.secondary.accent }}
            />
          }
        />
        <Stack direction="row" gap={theme.spacing.xxxl}>
          <Custom.Typography size={theme.font.xxs}>Bad</Custom.Typography>
          <Custom.Typography size={theme.font.xxs}>Excellent</Custom.Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
